import { axiosInstance } from "../authService";
import ApiUrlConstant from "../Constants";
import { apiKey } from "../../config/env";
const headers = { "Ocp-Apim-Subscription-Key": apiKey };
const headersFormData = { "Ocp-Apim-Subscription-Key": apiKey, "Content-Type": "multipart/form-data" };

const projectManagementService = {
  getProjects: (params = {}, token) => {
    return axiosInstance.get(ApiUrlConstant.projectListing(), {
      params, headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getProject: (id, token) => {
    return axiosInstance.get(ApiUrlConstant.getProject(id), {
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getStates: (token) => {
    return axiosInstance.get(ApiUrlConstant.getStates(), {
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getProjectTypes: (token) => {
    return axiosInstance.get(ApiUrlConstant.getProjectTypes(), {
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },
  createProject: (data, token) => {
    return axiosInstance.post(ApiUrlConstant.createProject(), data, {
      headers: {
        ...headersFormData,
        Authorization: `Bearer ${token}`,
      },
    });
  },
  deleteProject: (params = {}, token) => {
    return axiosInstance.delete(ApiUrlConstant.deleteProject(), {
      params, headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },
  archiveProject: (params = {}, token) => {
    return axiosInstance.delete(ApiUrlConstant.archiveProject(), {
      params, headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },
  updateProject: (data, token) => {
    return axiosInstance.put(ApiUrlConstant.updateProject(), data, {
      headers: {
        ...headersFormData,
        Authorization: `Bearer ${token}`,
      },
    })
  },
  getAllProjectList: (token) => {
    return axiosInstance.get(ApiUrlConstant.getAllProjectList(), {
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },
};

export default projectManagementService;

